import React from 'react';
import { useTranslation } from 'react-i18next';
import { APP_CONSTANTS } from '../constants/app';
import './ServicesSection.scss';

interface ServiceCardProps {
  icon: string | React.ReactElement;
  title: string;
  description: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ icon, title, description }) => {
  return (
    <div className="service-card">
      <div className="service-icon">{icon}</div>
      <h3 className="service-title">{title}</h3>
      <p className="service-description">{description}</p>
    </div>
  );
};

const ServicesSection: React.FC = () => {
  const { t } = useTranslation();

  const services = t('services', { returnObjects: true }) as Array<{
    icon: string | React.ReactElement;
    title: string;
    description: string;
  }>;
  services.forEach(service => {
    if (service.icon === '🇱🇹') {
      service.icon = <img src={APP_CONSTANTS.FLAGS.lt} alt="Lithuanian flag" className="flag-icon" />;
    }
  });

  return (
    <section className="services-section">
      <div className="container">
        <h2 className="section-title">{t('servicesTitle')}</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
